import { useEffect, useState } from 'react'
import { PageHeader } from '../../../shared/components'
import { faEdit, faExclamationCircle, faTrashCan } from '@fortawesome/free-solid-svg-icons'
import { Container, Card, Button, Col, Row } from 'react-bootstrap'
import { AppPaths } from '../../../shared/appConstants'
import { AlertComponent } from '../../../shared/components'
import { BackButton } from '../../../shared/components'
import { Icon } from '../../../shared/components'
import { Loading } from '../../../shared/components'
import { CategoryDetailDto } from 'appDtos'
import { useParams, useNavigate } from 'react-router-dom'
import { AdministrationPaths } from '../../../shared/api/constants'
import { useApi } from '../../../shared/hooks/useApi'
import { useApiHandleError } from '../../../shared/hooks/useApiHandleError'
import { formatDate } from '../../../shared/utils/utils'
import { ConfirmationModal } from '../../../shared/components'

export function CategoryDetail() {
  const { id } = useParams();
  const [categoryDetail, setCategoryDetail] = useState<CategoryDetailDto | null>(null);
  const [loading, setLoading] = useState(true);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const API = useApi();
  const { setError, errorMessage } = useApiHandleError();
  const goTo = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const response = await API.get(AdministrationPaths.GetCategoryDetail(Number(id)));
        if (response.data) {
          setCategoryDetail(response.data);
        }
      } catch (error) {
        setError(error)
      }
      setLoading(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDelete = () => {
    setLoading(true);
    setShowDeleteConfirmation(false);

    (async () => {
      try {
        await API.delete(AdministrationPaths.DeleteCategories(Number(id)));
        goTo(AppPaths.getCategories())
      } catch (error) {
        setError(error);
        setLoading(false);
      }
    })();
  };

  const deleteModalContent = (
    <div>
      <p>Are you sure you want to delete the <strong>{`${categoryDetail?.name}`}</strong> category?</p>
      <p className="text-danger fw-bold"> <Icon icon={faExclamationCircle}/> <strong>Important: </strong> This action cannot be undone.</p>
      <p>This action will permanently remove the selected item from the system. Any associated data or records may also be deleted.</p>
      <p>Please confirm your choice below:</p>
    </div>
  )

  return (
    <Container>
      <PageHeader pageTitle='Category Detail' />
      <AlertComponent message={errorMessage} />
      {loading ? (
        <Loading />
      ) : (
        categoryDetail ? (
          <Card className="border border-1 border-success">
            <Card.Header>
              <Card.Title className='display-5 fw-bold'>{categoryDetail.name}</Card.Title>
            </Card.Header>
            <Card.Body>
              <Row>
                <Col md="3">
                  <Card.Subtitle className="mt-3">Created Date</Card.Subtitle>
                  <Card.Title className="h1 fw-bold">{formatDate(categoryDetail.createdDate)}</Card.Title>
                </Col>
                <Col md="3">
                  <Card.Subtitle className="mt-3">Created By</Card.Subtitle>
                  <Card.Title className="h1 fw-bold">{categoryDetail.createdBy ?? 'System'}</Card.Title>
                </Col>
                {Boolean(categoryDetail.lastUpdatedDate) && <Col md="3">
                  <Card.Subtitle className="mt-3">Last Updated</Card.Subtitle>
                  <Card.Title className="h1 fw-bold">{formatDate(categoryDetail.lastUpdatedDate)}</Card.Title>
                </Col>}
                {Boolean(categoryDetail.lastUpdatedBy) && <Col md="3">
                  <Card.Subtitle className="mt-3">Last Updated By</Card.Subtitle>
                  <Card.Title className="h1 fw-bold">{categoryDetail.lastUpdatedBy}</Card.Title>
                </Col>}
              </Row>
            </Card.Body>
          </Card>
        ) : null
      )}
      {!loading && <>
        <BackButton />
        <Button onClick={() => goTo(AppPaths.getEditCategory(Number(categoryDetail?.categoryId)))} variant="success" className="mx-2 mt-5 fw-bold">
          {<Icon icon={faEdit} />} Edit
        </Button>
        <Button onClick={() => setShowDeleteConfirmation(true)} variant="danger" className="mx-2 mt-5 fw-bold">
          {<Icon icon={faTrashCan} />} Delete
        </Button>
      </>}
      <ConfirmationModal
        message={deleteModalContent}
        okHandler={handleDelete}
        cancelHandler={() => setShowDeleteConfirmation(false)}
        show={showDeleteConfirmation}
      />
    </Container>
  )
}
